import { Injectable } from '@angular/core';
import { DataTransformAbstractGet } from 'app/modules/global/classes/data.transform.abstract.up';
import { FeedInterface } from 'app/models/feed.model';
import { FieldInterface } from 'app/modules/common/inputs/custom-fields/fields/fields.interface';
import { FluidDatePipe } from 'app/modules/global/pipes/fluidDate.pipe';

@Injectable({
  providedIn: 'root',
})
export class FeedDataTransformGet extends DataTransformAbstractGet {
  constructor(private readonly _fluidDatePipe: FluidDatePipe) {
    super();
  }

  transform(feed: FeedInterface): FeedInterface {
    if (feed.parent) {
      feed.parent.fields = this.normalizeFields(feed.parent.fields);
    }
    feed.fields = this.normalizeFields(feed.fields);
    return feed;
  }

  protected normalizeFields(fields: FieldInterface[]): FieldInterface[] {
    if (!Array.isArray(fields)) {
      return fields;
    }

    fields.forEach((field: FieldInterface) => {
      //* // Formly v6
      //* field.props = field.templateOptions;
      //* delete field.templateOptions;

      if (
        field.type === 'input' &&
        (field.templateOptions.type === 'time' || field.templateOptions.type === 'date') &&
        field.defaultValue
      ) {
        field.defaultValue = this.removeUTC(field.defaultValue.toString());
      }
    });

    return fields;
  }
}
